// @ts-nocheck
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

const getOrderLineHasStartedShipping = (order: OrderModel, orderLineId: string) => {
    return (
        order.shipmentPackages?.some(x => x.shipmentPackageLineDtos?.some(y => y.orderHistoryLineId === orderLineId)) ??
        false
    );
};

export default getOrderLineHasStartedShipping;
